import de from './de-DE.js';
import en from './en-US.js';
export default {
  'de-DE': de,
  'en-US': en,
};
